var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoBobHorizontal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "bob-core-components-icon",
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "icons/_tint/logo-bob-horizontal"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "primarytint",
    points: "24.1,38.6 11.3,38.6 11.3,25.8 18.9,25.8 18.9,24.6 10,24.6 10,39.9 25.3,39.9 25.3,31 24.1,31  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "primarytint",
    d: "M20.2,29.7h5.1v-5.1h-5.1V29.7z M21.5,25.8h2.6v2.6h-2.6V25.8z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "primarytint",
    points: "26.6,28.4 26.6,29.7 30.5,29.7 30.5,19.4 20.2,19.4 20.2,23.3 21.5,23.3 21.5,20.7 29.2,20.7 29.2,28.4  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "primarytint",
    d: "M29.2,39.9h3.2c1.5,0,2.4-1,2.4-2.3c0-0.6-0.4-1.4-1.4-1.7c0.8-0.3,1-0.9,1-1.4c0-1.3-0.9-2.1-2.2-2.1h-3V39.9 z M30.8,33.9H32c0.5,0,0.7,0.3,0.7,0.8c0,0.4-0.3,0.8-0.7,0.8h-1.2V33.9z M30.8,36.7h1.5c0.6,0,0.8,0.5,0.8,0.9 c0,0.4-0.3,0.9-0.8,0.9h-1.5L30.8,36.7L30.8,36.7L30.8,36.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "primarytint",
    d: "M43.1,36.2c0-2.1-1.7-3.8-3.8-3.8c-2.1,0-3.8,1.7-3.8,3.8c0,2.1,1.7,3.8,3.8,3.8C41.5,40,43.1,38.3,43.1,36.2z  M39.4,38.4c-1.2,0-2.2-1-2.2-2.2c0-1.2,1-2.2,2.2-2.2c1.2,0,2.2,1,2.2,2.2C41.6,37.4,40.6,38.4,39.4,38.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "primarytint",
    d: "M48.6,35.9c0.8-0.3,1-0.9,1-1.4c0-1.3-0.9-2.1-2.2-2.1h-3v7.4h3.2c1.5,0,2.4-1,2.4-2.3 C50,37,49.6,36.2,48.6,35.9z M46,33.9h1.2c0.5,0,0.7,0.3,0.7,0.8c0,0.4-0.3,0.8-0.7,0.8H46V33.9z M47.5,38.5H46v-1.8h1.5 c0.6,0,0.8,0.5,0.8,0.9C48.3,38,48.1,38.5,47.5,38.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBobHorizontal);
export default __webpack_public_path__ + "static/media/logoBobHorizontal.c0f518da38da128b78b34f18947abff7.svg";
export { ForwardRef as ReactComponent };